export default __webpack_public_path__ + "1043603c53ad580a6ad1cea87914bb6c.svg";